// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			//suggestionMode: 'test',
			//suggestionPosition: 'left'
	}
};

const iphone = () => {
    if (typeof window === `undefined` || typeof navigator === `undefined`) return false;

    return /iPhone/i.test(navigator.userAgent || navigator.vendor || (window.opera && opera.toString() === `[object Opera]`));
};

(function() {
	BoostPFS.inject(this);

	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
		if (!searchBoxId) searchBoxId = this.searchBoxId;
		// Hide debut's search bar on mobile, and show our search bar instead
		if(jQ('.js-drawer-close').length > 0){
			setTimeout(function() {
				jQ('.js-drawer-close').trigger('click');
			});
		}
	};
  
  InstantSearchMobile.prototype.bindEvents = function() {
		this.$searchInput = jQ(this.selector.searchInput);
		this.$clearButtonElement = jQ(this.selector.clearButton);
		this.$closebuttonElement = jQ(this.selector.closebutton);
		this.$submitButtonElement = jQ(this.selector.submitButton);
		this.$topPanelElement = jQ(this.selector.topPanel);
		this.$overlayElement = jQ(this.selector.overlay);

		// apply autocomplete for search input
		this.searchBox = new SearchInput(this.inputMobileId, this.$searchInput);
		this.searchBox.refresh();

		// Add close button event
		this.$closebuttonElement.on('click', this.closeInstantSearchMobile.bind(this, true));
		// Add clear button event
		this.$clearButtonElement.on('click', this.clearInstantSearchMobile.bind(this));
    
		this.$searchInputs = jQ(this.selector.searchInputs);
    
		this.$searchInputs
			.on('click', this._onClickSearchBox.bind(this))
			.on('focus', this._onFocusSearchBox.bind(this))
			.on('keyup', this._onTypeSearchBoxEvent.bind(this));
		this.$searchInput.on('focus', this._onFocusMobileInput.bind(this));
		this.$searchInput.on('keyup', this._onKeyupSearchBox.bind(this));

		this.$targetInput = null;

		this.isBoundEvents = true;
    
    if(iphone()){
      document.querySelector('.search-btn input')?.addEventListener("touchstart", ()=>{
        if (!jQ('body').hasClass(Class.searchSuggestionMobileOpen)) {
          jQ('body').addClass(Class.searchSuggestionMobileOpen);
        }
        
        this.isOpen = true;
				// Close keyboard when scrolling on mobile		
				this.scrollSuggestionMobileEvent();
        // Display or not the clear button
        if (Utils.stripHtml(this.$searchInput.val()) == '') {
          this.$clearButtonElement.hide();
        } else {
          this.$clearButtonElement.show();
        }
        if (!this.$searchInput.is(':focus')) {
          // Display the Search box on Top
          this.$topPanelElement.show();
          this.$overlayElement.show();
          // Remove Lock focus on Menu mobile, Dialog,... which have tabindex=-1
          jQ('[tabindex="-1"]').removeAttr('tabindex').addClass(Class.searchSuggestionNoTabIndex);
          if (Utils.isMobile() && jQ("[data-open=true]").length > 0) {
            jQ("[data-open=true]").attr('data-open', false);
          }
          // Focus Search box
          setTimeout(() => {
            this.$searchInput.focus();
          }, 100);

        }
        
        this.searchBox.instantSearchResult.$wrapper.show();
      });
    }
	};

	SearchInput.prototype.customizeInstantSearch= function() {
		// Hide debut's search suggestion
		if (jQ('.predictive-search-wrapper').length > 0){
				jQ('.predictive-search-wrapper').hide();
		}
	};

	function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
		/* console.log('closeSuggestionMobile'); */
		jQ(searchBoxId).autocomplete('close');
		jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
		// Remove search box
		var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
		if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
		// Update current term for all search boxes
		setValueAllSearchBoxes();
		// Add back tabindex=-1
		jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
		// Return scrolling of body
		if(jQ('body').hasClass(Class.searchSuggestionMobileOpen)){    
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
	
		// Close search theme debut
		if(jQ('.js-drawer-close').length > 1){
			jQ('.js-drawer-close').trigger('click');
		}
	};
})();